import { render, staticRenderFns } from "./65.vue?vue&type=template&id=fef638ae&scoped=true&"
var script = {}
import style0 from "./65.vue?vue&type=style&index=0&id=fef638ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef638ae",
  null
  
)

export default component.exports